import { css } from 'lit'
import { csColorBackground, csColorBorder, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csFontBody } from './fonts.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const csFormControl = {
  backgroundColor: css`var(--cs-form-control-background-color, ${csColorBackground.primary})`,
  backgroundColorChecked: css`var(--cs-form-control-background-color-checked, ${csColorFunctional.info})`,
  backgroundColorCheckedHover: css`var(--cs-form-control-background-color-checked-hover, ${csColorFunctional.infoHover})`,
  backgroundColorSelected: css`var(--cs-form-control-background-color-selected, ${csColorBackground.secondary})`,
  backgroundColorDisabled: css`var(--cs-form-control-background-color-disabled, ${csColorBackground.disabled})`,
  borderColor: css`var(--cs-form-control-border-color, ${csColorBorder.light})`,
  borderColorDisabled: css`var(--cs-form-control-border-color-disabled, ${csColorBackground.disabled})`,
  borderColorError: css`var(--cs-form-control-border-color-error, ${csColorFunctional.error})`,
  borderColorHover: css`var(--cs-form-control-border-color-hover, ${csColorFunctional.infoHover})`,
  borderColorSuccess: css`var(--cs-form-control-border-color-success, ${csColorFunctional.success})`,
  borderColorChecked: css`var(--cs-form-control-border-color-checked, ${csColorFunctional.info})`,
  borderRadius: css`var(--cs-form-control-border-radius, ${csBorder.radiusMedium})`,
  borderWidth: css`var(--cs-form-control-border-width, ${csBorder.width})`,
  color: css`var(--cs-form-control-color, ${csColorText.body})`,
  colorHover: css`var(--cs-form-control-color-hover, ${csColorFunctional.infoHover})`,
  colorDisabled: css`var(--cs-form-control-color-disabled, ${csColorText.muted})`,
  fontFamily: css`var(--cs-form-control-font-family, ${csFontBody.fontFamily})`,
  fontSize: css`var(--cs-form-control-font-size, ${csFontBody.fontSize})`,
  height: css`var(--cs-form-control-height, 40px)`,
  paddingBlock: css`var(--cs-form-control-padding-y, 0)`,
  paddingInline: css`var(--cs-form-control-padding-x, ${csSpacing.spacing05})`,
  placeholderColor: css`var(--cs-form-control-placeholder-color, ${csColorText.placeholder})`,
  outlineFocus: css`var(--cs-form-control-outline-focus, -webkit-focus-ring-color auto 1px)`
}
